import APIClient from '@/shared/http/clients/api'

const resourceName = 'captacao-remunerada-diaria'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)
const GetModalidadeCaptacao = (data, config = {}) => APIClient.get(`${APICore}/${resourceName}/modalidade-captacao`, config, data)

/**
 * @name CaptacaoRemuneradaDiariaRepository
 * @description Captação Remunerada Diária
 * @type { Respository }
 */
const CaptacaoRemuneradaDiariaRepository = {
  Search,
  GetModalidadeCaptacao
}

export default CaptacaoRemuneradaDiariaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/captacaoremuneradadiaria.js